import { betMessages } from 'constants/toastMessages';

import { addToastAction } from 'core/widgets/Toast/actions';
import { setTotalBetAction } from 'core/widgets/User/actions';
import { put, select } from 'redux-saga/effects';
import { Notifications } from 'types';
import { ToastTypes } from 'types/toast';
import { OnPendingBetsMadeData } from '../types';

import { IRoundState, RoundStates } from 'core/widgets/RoundStates/types';
import { roundStateSelector } from 'core/widgets/RoundStates';
import {
  clearAllBetsAction,
  refreshBetsAction,
  setConfirmedBetAction,
} from 'core/widgets/RouletteBet/actions';

export function* onPendingBetsMadeSaga({
  type: notificationType,
  data: result,
}: OnPendingBetsMadeData) {
  if (notificationType === Notifications.PENDING_BETS_MADE) {
    if (result.accepted) {
      const roundState: IRoundState['roundState'] = yield select(roundStateSelector);
      if (roundState === RoundStates.RoundCanceled) {
        return;
      }

      const { bets, info } = result;

      const confirmedPendingBet = bets;

      yield put(refreshBetsAction({ past: [], present: {}, future: [] }));

      yield put(setTotalBetAction(result.total));
      yield put(setConfirmedBetAction([...confirmedPendingBet, ...info]));
      yield put(addToastAction({ type: ToastTypes.SUCCESS, value: betMessages.ACCEPTED }));
    }

    if (!result.accepted) {
      yield put(clearAllBetsAction());
    }
  }
}
